export const InternalServerErrorException = (message: string) => ({
    error: new Error(message),
    code: 500
})